import { Component, Input, Output, EventEmitter, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { MaintenanceService } from '../../../../techopsv4/services/maintenanceService';
import { ToastrService } from 'ngx-toastr';
import { MatTableDataSource } from '@angular/material/table';
import { FormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { SharedAuthService } from '../../../../shared/shared.auth.service';
interface LeaderNode {
  leader_level_1?: string;
  leader_level_1_msid?: string;
  leader_level_1_eid?: string;
  leader_level_2?: string;
  leader_level_2_msid?: string;
  leader_level_2_eid?: string;
  leader_level_3?: string;
  leader_level_3_msid?: string;
  leader_level_3_eid?: string;
  leader_level_4?: string;
  leader_level_4_msid?: string;
  leader_level_4_eid?: string;
  leader_level_5?: string;
  leader_level_5_msid?: string;
  leader_level_5_eid?: string;
  leader_level_6?: string;
  leader_level_6_msid?: string;
  leader_level_6_eid?: string;
  leader_level_7?: string;
  leader_level_7_msid?: string;
  leader_level_7_eid?: string;
  leader_level_8?: string;
  leader_level_8_msid?: string;
  leader_level_8_eid?: string;

  children?: LeaderNode[];
  selected?: boolean;
}

@Component({
  selector: 'app-heirarchy-mismatch',
  standalone: false,
  templateUrl: './heirarchy-mismatch.component.html',
  styleUrl: './heirarchy-mismatch.component.css'
})
export class HeirarchyMismatchComponent {
  @Input() tabSwitched: boolean;
  @Output() inputCleared = new EventEmitter<void>();
  isFundingAdmin: boolean;
  fundingAccessArr = [];
  displayedColumns: string[] = ['currentHeirarchy', 'activeHeirarchy', 'heirarchySegment', 'action'];
  displayedColumnsForExpand: string[] = ['ucmg', 'segment', 'otLabour'];
  expandedState: { [key: number]: boolean } = {};
  editMode: { [key: number]: boolean } = {};
  leaderSelected: { [key: number]: boolean } = {};
  heirarchyData: any[] = [];
  filteredHeirarchyData: any[] = [];
  selectedSegmentList: any = [];
  segmentList: any = ["Select All"];
  l1TableData: MatTableDataSource<any>[] = [];
  editingRowIndex: number | null = null;
  tempActiveHierarchy: any = null;
  editData: any;
  editedKeys: any[];
  hierarchyMismatches: number;
  ucmgIds: number;
  otTotal: any;
  selectedText: string = this.updateDropdownSelectedValues();
  showLoader: boolean = false;
  previousIndex: number;

  showHeirarchy: boolean = true;
  filteredDataForSb: LeaderNode[] = [];
  sbData: LeaderNode[] = [];
  searchText: string = '';
  OTLTextBox: string = '';
  expansionState = new Map<string, boolean>();
  selectedNodeId: string | null = null;
  selectedNode: any;
  existingNames: Set<string> = new Set();

  filteredHeirarchyDataSubject = new Subject<any[]>();

  constructor(public maintenanceService: MaintenanceService,
    private toaster: ToastrService, private cdr: ChangeDetectorRef,
   public sharedAuthService: SharedAuthService) {
  }


  ngOnInit() {
    this.getAccess()
    this.getMismetchHeirarchyData();
    this.getHierarachyList();

    this.filteredHeirarchyDataSubject.subscribe(filteredData => {
      this.l1TableData = filteredData.map(l1 => new MatTableDataSource([l1]));
      this.cdr.detectChanges(); // Ensure change detection
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['tabSwitched']) {
      this.clearSearch();
    }
    this.updateTopCard()
  }

  getAccess() {
    this.isFundingAdmin = this.sharedAuthService.getFundingAccessDetails('');
    this.fundingAccessArr = this.sharedAuthService.getFundingAccessDetails('Segmentlist');
  }

  initializeTable() {
    this.filterHierarchyData()
    this.l1TableData = this.filteredHeirarchyData.map((l1) =>
      new MatTableDataSource([l1])
    )
  }

  getTempLevels(objectData): string[] {
    return Object.keys(objectData).filter((key) => objectData[key]).map((key) => objectData[key])
  }

  startEditing(index: number) {
    this.editingRowIndex = index;
    const objectData = this.buildHierarchyFromParent(this.selectedNode);
    this.tempActiveHierarchy = this.getTempLevels(objectData)
    this.editedKeys = Object.keys(this.tempActiveHierarchy);
  }

  getIndentation(key: string): number {
    const match = key.match(/L(\d+)/);
    return match ? parseInt(match[1]) * 20 : 0;
  }

  buildHierarchyFromParent(parentData: any) {
    let current = null;
    while (parentData) {
      const newNode = {
        Leader_L1_Name: parentData?.leader_level_1 || (current ? current.Leader_L1_Name : null),
        Leader_L2_Name: parentData?.leader_level_2 || (current ? current.Leader_L2_Name : null),
        Leader_L3_Name: parentData?.leader_level_3 || (current ? current.Leader_L3_Name : null),
        Leader_L4_Name: parentData?.leader_level_4 || (current ? current.Leader_L4_Name : null),
        Leader_L5_Name: parentData?.leader_level_5 || (current ? current.Leader_L5_Name : null),
        Leader_L6_Name: parentData?.leader_level_6 || (current ? current.Leader_L6_Name : null),
        Leader_L7_Name: parentData?.leader_level_7 || (current ? current.Leader_L7_Name : null),
        Leader_L8_Name: parentData?.leader_level_8 || (current ? current.Leader_L8_Name : null),
      }
      current = newNode;
      parentData = parentData.parent;
    }
    return current
  }

  getMismetchHeirarchyData() {
    this.maintenanceService.getMismatchHeirarchyData().subscribe(res => {
      this.heirarchyData = res;
      if(res && res.length > 0) {
      this.getSegmentList();
      this.initializeTable();
      this.updateTopCard()
      }
    }, err => {
      this.toaster.error(err.error?.errors, '', { timeOut: 12000, positionClass: 'toast-top-center' });
    });
  }

  getSegmentList() {
    this.heirarchyData.forEach(obj => {
      if (!!obj.HierarchySegmentee && obj.HierarchySegmentee.includes(';')) {
        const arr = this.splitSegmentsBySemicolon(obj.HierarchySegmentee)
        arr.forEach(seg => {
          if (!this.segmentList.includes(seg)) {
            this.segmentList.push(seg);
          }
        });
      } else {
        if (!this.segmentList.includes(obj.HierarchySegmentee) && !!obj.HierarchySegmentee) {
          this.segmentList.push(obj.HierarchySegmentee);
        }
      }
    })
    this.selectedSegmentList = this.segmentList;
    this.selectedText = this.updateDropdownSelectedValues();
    this.segment.setValue(this.selectedSegmentList)
  }

  toggleEdit(index: number) {
    if (this.previousIndex !== index) {
      if (this.previousIndex !== undefined) {
        if (this.editMode[this.previousIndex] === true) {
          this.editMode[this.previousIndex] = false;
          this.leaderSelected[this.previousIndex] = false
        }
        this.previousIndex = index
      } else {
        this.previousIndex = index
      }
    }
    this.editMode[index] = !this.editMode[index];
    if (this.tempActiveHierarchy !== null) this.leaderSelected[index] = !this.leaderSelected[index]
    this.tempActiveHierarchy = null;
    this.searchText = '';
    this.showHeirarchy = true;

  }

  getLeaderLevel(node): string {
    return Object.keys(node).find(key => key.startsWith('Leader_') && key.endsWith('_Name')) || '';
  }

  getLeaderName(node: LeaderNode): string {
    return node.leader_level_1 || node.leader_level_2 || node.leader_level_3 || node.leader_level_4 || node.leader_level_5 || node.leader_level_6 || node.leader_level_7 || node.leader_level_8 || '';
  }

  onEdit() {
    this.showHeirarchy = !this.showHeirarchy;
  }

  highlightText(text: string): string {
    if (!this.searchText) return text;
    const regex = new RegExp(`(${this.searchText})`, 'gi');
    return text.replace(regex, `<span class="highlight">$1</span>`);
  }

  getHierarachyList() {
    this.maintenanceService.getHierarchyList().subscribe(res => {
      this.sbData = res;
      this.filteredDataForSb = JSON.parse(JSON.stringify(this.sbData));
    }, err => {
      console.log(err);
      this.toaster.error("Error fetching leader hierarchy list", '', {
         timeOut: 10000, positionClass: 'toast-top-center' 
      });
    });
  }

  applyAction() {
    const payload = {
      "Leader_L1_MSID": "mbonne5",
      "Leader_L2_MSID": "sdadlani",
      "Leader_L3_MSID": "sdadlani",
      "Leader_L4_MSID": "sdadlani",
      "Proposed_Leader_L1_MSID": "mbonne5",
      "Proposed_Leader_L1_Name": "Johnson, Molly Elizabeth",
      "Proposed_Leader_L1_eid": null,
      "Proposed_Leader_L1_mail": null,
      "Proposed_Leader_L2_MSID": "sdadlani",
      "Proposed_Leader_L2_Name": "Dadlani, Sandeep",
      "Proposed_Leader_L2_eid": null,
      "Proposed_Leader_L2_mail": null,
      "Proposed_Leader_L3_MSID": "sdadlani",
      "Proposed_Leader_L3_Name": "Dadlani, Sandeep",
      "Proposed_Leader_L3_eid": null,
      "Proposed_Leader_L3_mail": null,
      "Proposed_Leader_L4_MSID": "sli16",
      "Proposed_Leader_L4_Name": "Li, Shinan",
      "Proposed_Leader_L4_eid": null,
      "Proposed_Leader_L4_mail": null
    };
    this.maintenanceService.putLeaderOT(payload).subscribe(res => {
      if (res.Message === "Capital Demand Segment updated successfully") {
        this.toaster.success("Successfully updated segment", 'Successful', { timeOut: 10000, positionClass: 'toast-top-center' });
        console.log(res, 'Successfully updated segment');
      }
      if (res.status == 400) {
        this.toaster.error(res.message, '400 ERROR', { timeOut: 10000, positionClass: 'toast-top-center' });
      }
    });
  }

  toggleExpanded(index: number) {
    this.expandedState[index] = !this.expandedState[index]
  }

  toggleNode(node: LeaderNode) {
    const nodeId = this.getNodeId(node);
    this.expansionState.set(nodeId, !this.isExpanded(nodeId));
  }

  isExpanded(nodeId: string): boolean {
    return this.expansionState.get(nodeId) ?? false;
  }

  getNodeId(node: any): string {
    return (
      node.leader_level_1_msid ||
      node.leader_level_2_msid ||
      node.leader_level_3_msid ||
      node.leader_level_4_msid ||
      node.leader_level_5_msid ||
      node.leader_level_6_msid ||
      node.leader_level_7_msid ||
      node.leader_level_8_msid || ''
    );
  }

  filterTree() {
    this.filteredDataForSb = JSON.parse(JSON.stringify(this.sbData));
    if (this.searchText === '') { this.selectedNode = null }
    if (!this.searchText) {
      this.showHeirarchy = true;
      this.filteredDataForSb = JSON.parse(JSON.stringify(this.sbData));
      return;
    }
    this.filteredDataForSb = this.filterNodes(this.filteredDataForSb, this.searchText.toLowerCase());
    this.expansionState.clear();
    this.expandMatchingNodes(this.filteredDataForSb);
  }

  filterNodes(nodes: LeaderNode[], searchText: string): LeaderNode[] {
    this.showHeirarchy = false;
    return nodes.map(node => {
      const isMatch = this.getLeaderName(node).toLowerCase().includes(searchText)
      const newNode = { ...node };

      if (isMatch) {
        newNode.children = node.children || [];
        return newNode;
      }
      newNode.children = node.children ? this.filterNodes(node.children, searchText) : [];


      if (newNode.children.length > 0) {
        return newNode
      }
      return null!;
    }).filter(node => node !== null);
  }

  expandMatchingNodes(nodes: LeaderNode[]) {
    nodes.forEach(node => {
      node.children.forEach(child => {
        child["parent"] = node;
      });
      this.expansionState.set(this.getNodeId(node), true);
      if (node.children) {
        this.expandMatchingNodes(node.children)
      }
    })
  }

  clearSearch() {
    this.searchText = '';
    this.filteredDataForSb = [];
    this.expansionState.clear();
    this.setEditModesToFalse();
  }
  index: number;
  onSelectNode(node: LeaderNode, rowIndex: number) {
    if (rowIndex !== undefined) { this.index = rowIndex }
    if (this.isDisabled(node))
      return;
    const nodeId = this.getNodeId(node);
    this.tempActiveHierarchy = null;
    this.selectedNodeId = this.selectedNodeId === nodeId ? null : nodeId;
    this.selectedNode = node;
    const key = Object.keys(this.selectedNode);
    this.searchText = node[key[0]];
    this.showHeirarchy = true;
    this.leaderSelected[this.index] = true;
    this.startEditing(this.index)
  }

  isSelected(node: LeaderNode): boolean {
    return this.getNodeId(node) === this.selectedNodeId;
  }

  isDisabled(node: LeaderNode): boolean {

    const nodeName = this.getLeaderName(node);
    const isL1orL2 = !!node.leader_level_1 || !!node.leader_level_2;
    const existsInTable = this.existingNames.has(nodeName)
    return isL1orL2 || existsInTable
  }

  extractNames(data: any[]): void {
    for (const item of data) {
      Object.keys(item).forEach((key) => {
        if (key.startsWith('Leader_L') && key.endsWith('_Name')) {
          this.existingNames.add(item[key]);
        }
      });
      if (item.children?.length) {
        this.extractNames(item.children)
      }
    }
  }
  getLevelFromKey(node) {
    const keys = Object.keys(node);
    for (const key of keys) {
      const match = key.match(/(?:leader_level_|Proposed_Leader_L)(\d+)/);
      if (match) {
        return parseInt(match[1], 10);
      }
    }
    return -1;
  }

  getCurrentLeaderMsid(index: number, level: string): string {
    let node = this.heirarchyData[index];
    if (!node) return null;
    const levelMapping = {
      L1: 'Leader_L1_MSID',
      L2: 'Leader_L2_MSID',
      L3: 'Leader_L3_MSID',
      L4: 'Leader_L4_MSID',
      L5: 'Leader_L5_MSID',
      L6: 'Leader_L6_MSID',
      L7: 'Leader_L7_MSID',
      L8: 'Leader_L8_MSID',
    }

    if (level === 'L1') return node[levelMapping[level]] || null

    for (let i = 2; i <= 8; i++) {
      node = node.children?.find(child => child[levelMapping[`L${i}`]]);
      if (!node) return null;
      if (`L${i}` === level) return node[levelMapping[level] || null]
    }

    return null;
  }

  AddNewEntry(index: number , row: any) {
    this.setEditModesToFalse();
    this.leaderSelected[this.index] = true;
    this.searchText = '';
    const payload = {
      "Leader_L1_MSID": this.getCurrentLeaderMsid(index, 'L1'),
      "Leader_L2_MSID": this.getCurrentLeaderMsid(index, 'L2'),
      "Leader_L3_MSID": this.getCurrentLeaderMsid(index, 'L3'),
    };

    let curLeader = this.selectedNode;
    const proposedLeader = this.filteredHeirarchyData[index];
    if(this.editingRowIndex === index){
    while (curLeader && this.tempActiveHierarchy != null) {
      const curLeaderLevel = this.getLevelFromKey(curLeader);
      const curLeaderMSID = `leader_level_${curLeaderLevel}_msid`;
      const curLeaderName = `leader_level_${curLeaderLevel}`;
      payload[`Proposed_Leader_L${curLeaderLevel}_MSID`] = curLeader[curLeaderMSID];
      payload[`Proposed_Leader_L${curLeaderLevel}_Name`] = curLeader[curLeaderName];
      curLeader = curLeader.parent;
    }
    }
    let currentProposedLeader;

    if(payload[`Proposed_Leader_L1_MSID`] === null){
      currentProposedLeader = proposedLeader;
    }
   if(row && row[`Proposed_Leader_L1_MSID`] && !payload[`Proposed_Leader_L1_MSID`]){
    while (row && (row[`Proposed_Leader_L1_MSID`] !== null || row[`Proposed_Leader_L2_MSID`] !== null || row[`Proposed_Leader_L3_MSID`] !== null) ) {
      const propLeaderLevel = this.getLevelFromKey(row);
      const propLeaderMSID = `Proposed_Leader_L${propLeaderLevel}_MSID`;
      const propLeaderName = `Proposed_Leader_L${propLeaderLevel}_Name`;
      payload[`Proposed_Leader_L${propLeaderLevel}_MSID`] = row[propLeaderMSID];
      payload[`Proposed_Leader_L${propLeaderLevel}_Name`] = row[propLeaderName];
      row = row.children[0];
    }
  }

    this.leaderSelected[this.index] = true;

    this.showLoader = true;
    this.maintenanceService.postHierarchyMismatchLeader(payload).subscribe({
      next: (res) => {
        if (res.status === 400) {
          this.showLoader = false;
          this.toaster.error(res.message, '', { timeOut: 10000, positionClass: 'toast-top-center' });
          console.log('ERROR Adding Leader response');
        } else {
          this.showLoader = false;
          this.toaster.success("Successfully added leader", '', { timeOut: 10000, positionClass: 'toast-top-center' });
          this.getMismetchHeirarchyData();
          this.searchText = '';
          this.tempActiveHierarchy = null;
          this.leaderSelected[index] = false;
        }
      },
      error: (err) => {
        this.showLoader = false;
        this.tempActiveHierarchy = null
        if (err.status === 400) {
          this.toaster.error(err.error.message, '', { timeOut: 10000, positionClass: 'toast-top-center' });
          console.log('ERROR Adding Leader response');
        } else {
          console.error('Error occurred:', err);
        }
      }
    });
  }

  segment = new FormControl([]);
  onSelectionChange(event: any) {
    const selectedValues = event.value;
    const isSelectAllEnabled = selectedValues.includes('Select All');

    if (isSelectAllEnabled) {
      if (selectedValues.length < this.selectedSegmentList.length) {
        const deselectedItem = this.selectedSegmentList.find(item => !selectedValues.includes(item));
        this.selectedSegmentList = [deselectedItem];
        this.segment.setValue([deselectedItem]);
      } else {
        this.selectedSegmentList = this.segmentList;
        this.segment.setValue(this.selectedSegmentList);
      }
    } else {
      const deselectedItem = this.selectedSegmentList.find(item => !selectedValues.includes(item));
      if (deselectedItem === "Select All") {
        this.selectedSegmentList = [];
        this.segment.setValue([]);
      } else if (this.selectedSegmentList.length >= 0) {
        this.selectedSegmentList = selectedValues;
        this.segment.setValue(selectedValues);
      } else if (selectedValues.length === 0) {
        this.selectedSegmentList = [];
        this.segment.setValue([]);
      }
    }
    this.selectedText = this.updateDropdownSelectedValues();
    this.initializeTable();
    this.updateTopCard()
  }

  setEditModesToFalse() {
    for (const key in this.editMode) {
      if (Object.prototype.hasOwnProperty.call(this.editMode, key)) {
        this.editMode[key] = false;
      }
    }
  }

  filterHierarchyData() {
    this.filteredHeirarchyData = [];
    if (this.selectedSegmentList.includes("Select All")) {
      this.filteredHeirarchyData = this.heirarchyData;
    } else {
      this.heirarchyData.forEach(obj => {
        if (!!obj.HierarchySegmentee && obj.HierarchySegmentee.includes(";")) {
          const arr = this.splitSegmentsBySemicolon(obj.HierarchySegmentee);
          let shouldBreak = false;
          arr.forEach(seg => {
            if (this.selectedSegmentList.includes(seg) && shouldBreak === false) {
              this.filteredHeirarchyData.push(obj);
              shouldBreak = true;
            }
          });
        }
        if (this.selectedSegmentList.includes(obj.HierarchySegmentee)) {
          this.filteredHeirarchyData.push(obj);
        }
      });
    }

    this.filteredHeirarchyDataSubject.next(this.filteredHeirarchyData);
  }

  updateTopCard() {
    this.updateHierarchyMismatches();
    this.updateUcmgIdsCount();
    this.updateOTTotal();
  }

  updateHierarchyMismatches() {
    let hierMismatchCount = 0;
    this.filteredHeirarchyData.forEach(() => {
      hierMismatchCount++;
    });
    this.hierarchyMismatches = hierMismatchCount;
  }

  updateUcmgIdsCount() {
    let ucmgList = [];
    this.filteredHeirarchyData.forEach(arr => {
      ucmgList.push(arr.ucmgs.map(ucmg => ucmg.UCMG_ID));
      ucmgList = [...new Set(ucmgList.flat())];
    });
    this.ucmgIds = ucmgList.length;
  }

  updateOTTotal() {
    let otTotalCount = 0.0;
    this.filteredHeirarchyData.forEach(arr => {
      arr.ucmgs.forEach(ucmg => {
        otTotalCount += ucmg.Optum_Tech_Labour;
      });
    });

    this.otTotal = otTotalCount;
  }

  checkAccess(i: any) {
    if (this.isFundingAdmin) { return true; }
    let segRole = this.filteredHeirarchyData[i].segmentId;
    if (segRole && segRole.includes(';')) {
      segRole = this.splitSegmentsBySemicolon(segRole);
      for (const role of segRole) {
        if (this.fundingAccessArr.includes(role)) {
          return true;
        }
      }
    }
    if (this.fundingAccessArr.includes(segRole)) {
      return true;
    }
    return false;
  }

  splitSegmentsBySemicolon(inputString) {
    if (inputString) {
      return inputString.split(';');
    }
    return [];
  }

  updateDropdownSelectedValues() {
    if (this.selectedSegmentList.includes("Select All")) {
      const searchValuesNoSA = this.selectedSegmentList.filter(obj => obj !== "Select All");
      return searchValuesNoSA.toString();
    } else if (this.selectedSegmentList.length === 0) {
      return 'Select Segment';
    } else {
      return this.selectedSegmentList.toString();
    }
  }
}
